import styled from '@emotion/styled/macro'
import { Box } from '@mui/material'
import theme from 'theme'

/* Mirrors the operational view's AG Grid set filter (ui/components/records-grid/recordsGrid.styles
   .ts), which this panel replaces rather than extends — AG Grid paints none of its own chrome
   around a custom filter component, so every value here has to be restated. */
export const FilterPanel = styled(Box)`
  width: 244px;
  box-sizing: border-box;
  padding: ${theme.spacing.xSmall}px 0;
  display: flex;
  flex-direction: column;
  background: ${theme.colors.devicesPopupBg};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  box-shadow: 0 4px 8px 0 ${theme.colors.primaryDark};
  font-family: ${theme.typography.fontFamily.primary};

  .search-wrap {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 ${theme.spacing.xSmall}px ${theme.spacing.xSmall}px;

    &::before {
      content: '';
      position: absolute;
      left: ${theme.spacing.small}px;
      width: 20px;
      height: 20px;
      pointer-events: none;
      background: ${theme.colors.devicesSecondaryText};
      mask-image: url('/search-mask-image.svg');
      mask-repeat: no-repeat;
      mask-position: center;
    }
  }

  .search-field {
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    padding: 0 ${theme.spacing.small}px 0 48px;
    background: ${theme.colors.devicesInputBg};
    border: 1px solid ${theme.colors.devicesInputBg};
    border-radius: ${theme.attributes.borderRadius.mediumSmall};
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 20px;

    &::placeholder {
      color: ${theme.colors.devicesSecondaryText};
      font-size: ${theme.typography.fontSize.large};
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
    }

    &:focus {
      outline: none;
      border-color: ${theme.colors.cta};
    }
  }

  .value-list {
    display: flex;
    flex-direction: column;
    max-height: 144px;
    overflow-y: auto;
    margin-right: 4px;

    &::-webkit-scrollbar {
      width: 4px;
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      box-shadow: none;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.surfaceContainerBackground};
      border-radius: 2px;
    }
  }

  .value-row {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
    padding: ${theme.spacing.half}px ${theme.spacing.small}px;
    border: none;
    background: none;
    cursor: pointer;
    text-align: left;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 22px;

    &:hover {
      background: ${theme.colors.menuItemHover};
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.cta};
      outline-offset: -2px;
    }

    &[aria-checked='true'],
    &[aria-checked='mixed'] {
      color: ${theme.colors.menuItemText};
    }

    .value-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.is-muted .value-text {
      font-style: italic;
    }
  }

  /* Served from /public so CSS minification cannot mangle an inline data URI. */
  .value-box {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    background-image: url('/checkbox-unchecked.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    &.is-checked {
      background-image: url('/checkbox-checked.svg');
    }

    &.is-indeterminate {
      background-image: url('/checkbox-indeterminate.svg');
    }
  }

  html[data-theme='light'] & .value-box {
    background-image: url('/checkbox-unchecked-light.svg');

    &.is-checked {
      background-image: url('/checkbox-checked-light.svg');
    }

    &.is-indeterminate {
      background-image: url('/checkbox-indeterminate-light.svg');
    }
  }

  .panel-note {
    padding: ${theme.spacing.half}px ${theme.spacing.small}px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    line-height: 18px;
  }

  .panel-note.is-warning {
    color: ${theme.colors.inputError};
  }

  .panel-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    button {
      margin-left: 0;
      padding: ${theme.spacing.xSmall}px ${theme.spacing.small}px;
      background: transparent;
      outline: 0;
      border: 0;
      cursor: pointer;
      width: fit-content;
      height: fit-content;
      color: ${theme.colors.cta};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-weight: ${theme.typography.fontWeight.extraThick};
      line-height: 22px;

      &:hover {
        color: ${theme.colors.buttonHollowHover};
      }

      &:disabled {
        opacity: 0.38;
        cursor: default;
      }
    }
  }
`
